import { defineMessages } from 'react-intl';

const messageDescriptors = defineMessages({
  ShipTo: {
    description: "Warning message when editing an order's shipTo and has an active label",
    defaultMessage: 'Active label(s) have been created with a previous address. It is recommended that those are voided.',
    id: 'Em1jLz',
  },
});

export default (errorContext) => {
  const { propertyName } = errorContext;
  return messageDescriptors[propertyName];
};
